import { ChannelId } from '../../../types/gptTypes';
import CustomTag from '../../shared/CustomTag';

type Props = {
  channelId: ChannelId;
};

function StreamingChannelTag({ channelId }: Readonly<Props>) {
  const channelName = (() => {
    if (channelId === ChannelId.front) return 'Frontal';
    if (channelId === ChannelId.dome) return 'Domo';
    return 'Interna';
  })();
  return (
    <CustomTag
      color="#fff"
      content={channelName}
    />
  );
}

export default StreamingChannelTag;
